<template>
    <div class="editorBox">
        <span class="fl mytitle">{{title}}</span>
        <a-button type="link" class="fr" @click="handleFormat">格式化</a-button>
        <a-radio-group v-model="currentLanguage" id="myJsonXmlradio">
            <a-radio v-for="item in languages" :value="item" :key="item" name="type">
                {{item}}
            </a-radio>
        </a-radio-group>
        <editor v-model="currentCode"  @init="editorInit" :lang="currentLanguage" theme="monokai" width="100%" :height="height" style="font-size:15px;margin-top:10px;"></editor>
    </div>
</template>
<script>
import Editor from 'vue2-ace-editor'
import {
    check_string_type,
    formatJson,
    string_to_xml_wrap
} from "@/utils/data_format_utils";

export default {
    model:{
        prop:'value',
        event:'change'
    },
    props:{
        language:{
            type:String,
            default:'json,xml,text',//String,// text   text,json  text,json,xml
        },
        title:String,
        value:String,
        height:{
            type:Number,
            default:400
        }
    },

    data() {
        return {
            languages:[],
            currentLanguage: '',
            currentCode:'',
        }
    },
    components: {
        Editor
    },
    methods: {
        editorInit() {
            require('brace/ext/language_tools') //language extension prerequsite...
            require('brace/mode/xml')
            require('brace/mode/json')
            require('brace/mode/javascript') //language
            require('brace/mode/less')
            require('brace/theme/monokai')
            require('brace/snippets/javascript') //snippet
        },
        handleFormat(){
            let tempLan = check_string_type(this.currentCode)
            if(this.currentLanguage == 'xml' && tempLan == 'XML'){
                this.currentCode = string_to_xml_wrap(this.currentCode)
                this.$emit('change',this.currentCode);
            }
            else if(this.currentLanguage == 'json' && tempLan=='JSON'){
                this.currentCode = formatJson(this.currentCode)
                this.$emit('change',this.currentCode);
            }
            else if(this.currentLanguage == 'text' && tempLan=='TEXT'){
                console.log('Text')
            }
            else{
                this.message.warn('当前选中的语言不符，输入语言为：' + tempLan)
            }
        },
        handleChange(v){
            this.value = v;
            this.$emit('change',v);
        }
    },
    mounted() {
        let lan_ = this.language.split(',');
        this.currentLanguage = lan_[0]
        this.languages = lan_
    },
    watch:{
        'value'(nv){
            console.log('new val:' + nv)
            if(nv){
                this.currentCode = nv
            }
            else{
                this.currentCode = ''
            }
        },
        'currentCode'(nv){
            this.$emit('change',nv);
        }
    }
}

</script>

<style scoped>
  .editorBox{
      margin: 20px 0;
      background-color: #272822;
  }

  #myJsonXmlradio{
      margin: 5px 0; 
      float:right;
  }

  .mytitle{
      color: white;
      padding: 5px 10px;
  }
</style>

<style>

   /* jsoneditor右上角默认有一个链接,加css去掉了 */
  .jsoneditor-poweredBy{
     display: none;
  }

  #myJsonXmlradio .ant-radio-wrapper{
      color: white;
  }
</style>